import React from 'react'
import './Section.css'
import { useScrollReveal } from '../../hooks/useScrollReveal'

// Every section reads as one more open tab in the same editor window as the
// Home hero  the tab name is just the stage id capitalized as a filename,
// no separate copy to keep in sync.
const tabName = (stage) =>
  stage ? `${stage.charAt(0).toUpperCase()}${stage.slice(1)}.jsx` : ''

const Section = (props) => {
  const revealRef = useScrollReveal({ y: 30, stagger: 0.15 })
  return (
    <section
      className={`cinematic-section ${props.stage}`}
      id={props.stage}
      data-scene-stage={props.stage}
    >
      <div ref={revealRef}>
        <span className="section-tab" data-reveal-item aria-hidden="true">
          <span className="section-tab-dot" />
          {tabName(props.stage)}
        </span>
        <h1 className="section-title" data-reveal-item>
          {props.title}
        </h1>
        <div className="underline" data-reveal-item></div>
      </div>
      {props.children}
    </section>
  )
}

export default Section
